import { render } from "./StockReport.vue?vue&type=template&id=65a28fb6&ts=true"
import script from "./StockReport.vue?vue&type=script&lang=ts"
export * from "./StockReport.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__